
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[requestId]",
      function () {
        return require("private-next-pages/[requestId]/index.tsx");
      }
    ]);
  